// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"223":"2dffdd611b9dfb738ba3","878":"a7c56a6c4ca3cf684515"}[chunkId] + ".chunk.js";
};